import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const { FiCheck } = FiIcons;

function About() {
  return (
    <section className="section about-section" id="about">
      <div className="container about-grid">
        <Reveal className="about-photos">
          <img
            className="about-main-photo"
            src="https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?auto=format&fit=crop&w=900&q=85"
            alt="Stylist at work in a bright salon"
          />
          <img
            className="about-inset-photo"
            src="https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/2feee616b2c7bff6ad75cef136d50128.webp"
            alt="Beauty professional applying makeup"
          />
          <div className="experience-badge">
            <strong>08</strong>
            <span>YEARS OF<br />EXPERIENCE</span>
          </div>
        </Reveal>
        <Reveal className="about-copy" delay={0.1}>
          <SectionHeading
            eyebrow="A salon that feels like yours"
            title="Care that brings out your kind of beautiful."
          />
          <p>At Saffron & Sage, good service starts with listening. Our team brings together expert hair, skin, makeup and grooming care in a warm, easy-going space made for every guest.</p>
          <p>From your regular trim to a special celebration, we take the time to understand what feels right for you.</p>
          <ul className="check-list">
            <li><SafeIcon icon={FiCheck} /> Skilled, thoughtful professionals</li>
            <li><SafeIcon icon={FiCheck} /> Trusted products for every service</li>
            <li><SafeIcon icon={FiCheck} /> A welcoming unisex salon experience</li>
          </ul>
          <a href="#team" className="text-link">Meet the team <span>↗</span></a>
        </Reveal>
      </div>
    </section>
  );
}

export default About;
